/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Too_LongInputs */



/**
* | output |
* | --- |
* | "Your message is too long. {count} characters at most." |
*
* @param {Chat_Too_LongInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_too_long = /** @type {((inputs: Chat_Too_LongInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Too_LongInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Je bericht is te lang. Maximaal ${i?.count} tekens.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Votre message est trop long. ${i?.count} caractères au maximum.`)
	return /** @type {LocalizedString} */ (`Your message is too long. ${i?.count} characters at most.`)
});